module.exports = __webpack_public_path__ + "img/chess.973328a5.svg";